import { createSlice } from '@reduxjs/toolkit'
import { addArea, addEducationQualification, editArea, editEducationQualification, getArea, getAreaByCityId, getCity, getCityByStateId, getEducationQualification, getState, getTempArea, getTempAreaByCityId, getTempCity, getTempCityByStateId } from '../../builders/masterDataSet/masterDataSet.builder'

const initialState = {
  loading: false,
  cites: null,
  states: null,
  areas: null,
  tempCities: null,
  tempAreas: null,
 stateCities: [],
 CitiesAreas:[],
 tempStateCities: [],
 tempCitiesAreas:[],
 educationQualificationData:[],
}

const masterDataSetSlice = createSlice({
  name: 'masterDataSet',
  initialState,
  reducers: {
    clearExtraReducers: (state) => {
      (state.loading = false),
        (state.cites = []),
        (state.areas = []),
        (state.states = []),
        (state.tempCities = []),
        (state.tempAreas = [])
    },
  },
  extraReducers: (builder) => {

    //Permenent Address
    builder.addCase(getState.pending, (state) => {
      state.loading = true
      state.states = []
    })
    builder.addCase(getState.fulfilled, (state, action) => {
      state.loading = false
      state.states = action?.payload?.result
    })
    builder.addCase(getState.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getArea.pending, (state) => {
      state.loading = true
      state.areas = []
    })
    builder.addCase(getArea.fulfilled, (state, action) => {
      state.loading = false
      state.areas = action?.payload?.result?.area
    })
    builder.addCase(getArea.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getCity.pending, (state) => {
      state.loading = true
      state.cites = []
    })
    builder.addCase(getCity.fulfilled, (state, action) => {
      state.loading = false
      state.cites = action?.payload?.result?.cities
    })
    builder.addCase(getCity.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getCityByStateId.pending, (state) => {
      state.loading = true
      state.stateCities = []
    })
    builder.addCase(getCityByStateId.fulfilled, (state, action) => {
      state.loading = false
      state.stateCities = action?.payload
    })
    builder.addCase(getCityByStateId.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getAreaByCityId.pending, (state) => {
      state.loading = true
      state.CitiesAreas = []
    })
    builder.addCase(getAreaByCityId.fulfilled, (state, action) => {
      state.loading = false
      state.CitiesAreas = action?.payload
    })
    builder.addCase(getAreaByCityId.rejected, (state) => {
      state.loading = false
    })

    //Temporary Address
    builder.addCase(getTempArea.pending, (state) => {
      state.loading = true
      state.tempAreas = []
    })
    builder.addCase(getTempArea.fulfilled, (state, action) => {
      state.loading = false
      state.tempAreas = action?.payload?.result?.area
    })
    builder.addCase(getTempArea.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getTempCity.pending, (state) => {
      state.loading = true
      state.tempCities = []
    })
    builder.addCase(getTempCity.fulfilled, (state, action) => {
      state.loading = false
      state.tempCities = action?.payload?.result?.cities
    })
    builder.addCase(getTempCity.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getTempCityByStateId.pending, (state) => {
      state.loading = true
      state.tempStateCities = []
    })
    builder.addCase(getTempCityByStateId.fulfilled, (state, action) => {
      state.loading = false
      state.tempStateCities = action?.payload
    })
    builder.addCase(getTempCityByStateId.rejected, (state) => {
      state.loading = false
    })
    builder.addCase(getTempAreaByCityId.pending, (state) => {
      state.loading = true
      state.tempCitiesAreas = []
    })
    builder.addCase(getTempAreaByCityId.fulfilled, (state, action) => {
      state.loading = false
      state.tempCitiesAreas = action?.payload
    })
    builder.addCase(getTempAreaByCityId.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(addArea.pending, (state) => {
      state.loading = true
    })
    builder.addCase(addArea.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(addArea.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(editArea.pending, (state) => {
      state.loading = true
    })
    builder.addCase(editArea.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(editArea.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(getEducationQualification.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getEducationQualification.fulfilled, (state, action) => {
      state.loading = false
      state.educationQualificationData = action.payload
    })
    builder.addCase(getEducationQualification.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(addEducationQualification.pending, (state) => {
      state.loading = true
    })
    builder.addCase(addEducationQualification.fulfilled, (state, action) => {
      state.loading = false
      state.educationQualificationData = action.payload
    })
    builder.addCase(addEducationQualification.rejected, (state) => {
      state.loading = false
    })

    builder.addCase(editEducationQualification.pending, (state) => {
      state.loading = true
    })
    builder.addCase(editEducationQualification.fulfilled, (state, action) => {
      state.loading = false
      state.educationQualificationData = action.payload
    })
    builder.addCase(editEducationQualification.rejected, (state) => {
      state.loading = false
    })
    
  },
})

export const { clearExtraReducers } = masterDataSetSlice.actions

export default masterDataSetSlice.reducer
